<template>
  <div class="chat-toolbar">
    <div class="chat-toolbar-file-dialog bottom-12" ref="file_dialog">
      <button class="chat-toolbar-file-dialog-button" @click="ShowImageDialog">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clip-rule="evenodd" />
        </svg>
        <p class="ml-2">Фото</p>
      </button>
      <button class="chat-toolbar-file-dialog-button" @click="ShowFileDialog">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clip-rule="evenodd" />
        </svg>
        <p class="ml-2">Файл</p>
      </button>
    </div>
    <div class="col-1 flex justify-center items-end">
      <button class="chat-toolbar-button" @click="$event.stopPropagation();ToggleFileDialog()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
        </svg>
      </button>
    </div>
    <div class="col-10">
      <div class="chat-toolbar-input-container">
        <div class="chat-toolbar-message" v-if="messageToAnswer !== null">
          <p class="chat-toolbar-message-indicator">&nbsp;</p>
          <div class="flex flex-col">
            <p class="ml-2 whitespace-pre-wrap">{{messageToAnswer.text}}</p>
            <div class="message-file-content" v-if="messageToAnswer.files != null && Object.keys(messageToAnswer.files).length > 0">
              <div class="message-file" :title="file.Name" v-for="(file,file_index) in $parent.GetMessageFiles(messageToAnswer)" :key="'file_'+file_index">
                <img :class="!file.IsImage || !file.IsLoaded ? 'w-6 h-6' : 'message-file-image'" :src='file.FileImage' :alt="file.IsImage ? file.Name : file.Exstension"/>
                <p class="ml-2 truncate" v-if="!file.IsImage || !file.IsLoaded">{{file.Name}}</p>
              </div>
            </div>
          </div>
          <button class="ml-auto mb-auto mt-0.5 text-danger" @click="messageToAnswer = null">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
        <textarea class="chat-toolbar-input" :rows="1" :maxlength="maxMessageLength" :placeholder="messagePlaceholder" :style="computedStyles" v-model="val" @focus="resize" @keydown="parseKeys" @paste="getClipboardFile" ref="msg_inp"></textarea>
        <div class="chat-toolbar-file-container" v-if="fileInputBuffer.length > 0">
          <div class="flex flex-row items-center">
            <div class="chat-toolbar-file" :title="file.name" v-for="(file, index) in fileInputBuffer" :key="'file_' + index">
              <img :class="!file.isImage ? 'w-10 h-10' : ''" :src='file.fileImage' :alt="file.isImage ? file.name : file.exstension"/>
              <button class="chat-toolbar-file-close" @click="fileInputBuffer.splice(index, 1)">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1 flex justify-center items-end">
      <button class="chat-toolbar-button" @click="submit" :disabled="disableSendButton">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 rotate-45 -translate-y-[10%] translate-x-[10%]" viewBox="0 0 20 20" fill="currentColor" :class="disableSendButton ? 'invisible' : ''" >
          <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
        </svg>
      </button>
    </div>
  </div>
</template>
<script>

const toBase64 = (file) => new Promise((resolve, reject) => {
  let reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = (error) => reject(error)
})

export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    minHeight: {
      type: Number,
      default: null
    },
    maxHeight: {
      type: Number,
      default: null
    },
    messagePlaceholder: {
      type: String,
      default: ""
    },
    maxMessageLength: {
      type: Number,
      default: null,
    },
    messageToAnswer: {
      type: Object,
      default: null,
    },
    onSubmit: {
      type: Function,
      default: ()=>{}
    },
    filesWhiteList: {
      type: Object,
      default: null
    },
    fileInputAccept: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      val: "",
      maxHeightScroll: false,
      height: 'auto',
      showFileDialog: false,
      fileInputBuffer: [],
      disableSend: false,
      _default: "data:image/svg+xml;base64,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",
    }
  },
  computed: {
    disableSendButton() {
      let hasFiles = this.fileInputBuffer.length > 0
      let hasText = this.val.length > 0
      return !(hasFiles || hasText) || this.disableSend
    },
    computedStyles() {
      return {
        resize: 'none',
        height: this.height,
        overflow: this.maxHeightScroll ? 'auto' : 'hidden'
      }
    }
  },
  watch: {
    value(val) {
      this.val = val
    },
    val(newVal, oldVal) {
      this.val = oldVal !== null && oldVal.length > 0 ? newVal : newVal.trim()
      this.$nextTick(this.resize)
    },
    minHeight() {
      this.$nextTick(this.resize)
    },
    maxHeight() {
      this.$nextTick(this.resize)
    }
  },
  methods: {
    Get() {
      return JSON.parse(JSON.stringify(this.val))
    },
    ToggleFileDialog(mode) {
      if (mode == "off") {
        this.$refs.file_dialog.classList.add("hide")
        setTimeout(()=>{
          if (this.$refs.file_dialog == null) return
          this.$refs.file_dialog.classList.remove("hide")
          this.$refs.file_dialog.classList.remove("show")
        }, 400)
        return
      }
      let isShow = this.$refs.file_dialog.classList.contains("show")
      if (isShow) {
        this.$refs.file_dialog.classList.add("hide")
        setTimeout(()=>{
          this.$refs.file_dialog.classList.remove("hide")
          this.$refs.file_dialog.classList.remove("show")
        }, 400)
        return
      }
      this.$refs.file_dialog.classList.add("show")
    },
    async ShowImageDialog() {
      let fileInput = document.createElement("input")

      fileInput.type = "file"

      fileInput.accept = "image/*"

      if (this.fileInputAccept !== null && this.fileInputAccept.images !== null && this.fileInputAccept.images.length > 0)
        fileInput.accept = this.fileInputAccept.images.join(",")

      fileInput.multiple = true

      fileInput.click()

      fileInput.onchange = (e) => { this.parseFiles(e, true) } 
    },
    async ShowFileDialog() {
      let fileInput = document.createElement("input")

      fileInput.type = "file"

      if (this.fileInputAccept !== null && this.fileInputAccept.files !== null && this.fileInputAccept.files.length > 0)
        fileInput.accept = this.fileInputAccept.files.join(",")

      fileInput.multiple = true

      fileInput.click()

      fileInput.onchange = this.parseFiles
    },
    async parseFiles(e, asImage = false) {
      let filesData = e.target.files

      filesData = [...filesData]

      let fileBuff = []

      for (var i in filesData) {
        var file = filesData[i]
        var target = e.target
        try {
          if (asImage) {
            var res = await toBase64(file)
            fileBuff.push({
              name: file.name,
              isImage: true,
              type: "image",
              fileImage: res,
              data: file
            })
          } else {
            var ext = file.name.split(".").slice(-1)[0].toLowerCase()
            if (this.filesWhiteList !== null && !(ext in this.filesWhiteList) && !this.fileInputAccept.includes(`.${ext}`)) continue

            fileBuff.push({
              name: file.name,
              isImage: false,
              type: "file",
              exstension: ext,
              fileImage: this.filesWhiteList !== null ? this.filesWhiteList[ext] || this.filesWhiteList._default : this._default,
              data: file
            })
          }
          
          target.remove()
        } catch (error) {
          this.$root.ShowToast(`Не удалось загрузить файл: ${error}`, "error")
        }

        this.fileInputBuffer = this.fileInputBuffer.concat(fileBuff)
      }
    },
    async getClipboardFile(e) {
      var items = (e.clipboardData || e.originalEvent.clipboardData).items

      for (var i in items) {
        var item = items[i]

        if (item.kind === 'file') {
          e.preventDefault()

          var fileBuff = []
          var blob = item.getAsFile()

          var isImage = blob.type.split("/").at(0) == "image"

          if (isImage) {
            var res = await toBase64(blob)
            fileBuff.push({
              name: blob.name,
              isImage: true,
              type: "image",
              fileImage: res,
              data: blob
            })
          } else {
            var ext = blob.name.split(".").slice(-1)[0].toLowerCase()

            if (this.filesWhiteList !== null && !(ext in this.filesWhiteList) && !this.fileInputAccept.includes(`.${ext}`)) continue

            fileBuff.push({
              name: blob.name,
              isImage: false,
              type: "file",
              exstension: ext,
              fileImage: this.filesWhiteList !== null ? this.filesWhiteList[ext] || this.filesWhiteList._default : this._default,
              data: blob
            })
          }

          this.fileInputBuffer = this.fileInputBuffer.concat(fileBuff)
        }
      }
    },
    parseKeys(e) {
      let keyCode = e.which || e.keyCode
      if (keyCode == 13) {
        e.preventDefault()
        if (e.shiftKey) {
          let temp = ""
          let cursorPos = e.target.selectionStart
          temp = this.val.slice(0, cursorPos) + String.fromCharCode(13, 10) + this.val.slice(cursorPos)
          this.val = temp
          return
        }
        if ((this.val == null || this.val == "") && this.fileInputBuffer.length == 0) return
        this.submit()
      }
    },
    resize() {
      this.ToggleFileDialog("off")
      this.height = `auto`
      this.$nextTick(() => {
        let contentHeight = this.$refs.msg_inp.scrollHeight + 1

        if (this.minHeight) {
          contentHeight = contentHeight < this.minHeight ? this.minHeight : contentHeight
        }

        if (this.maxHeight) {
          if (contentHeight > this.maxHeight) contentHeight = this.maxHeight
        
          this.maxHeightScroll = contentHeight > this.maxHeight
        }

        this.height = `${contentHeight}px`
      })

      return this
    },
    submit() {
      if (this.disableSend) return
      this.onSubmit({value: String(this.val), files: [].concat(this.fileInputBuffer), messageToAnswer: this.messageToAnswer})
      this.disableSend = true
      setTimeout(()=>{this.disableSend = false}, this.$store.state.chatSendCD * 1000)
      this.val = ""
      this.fileInputBuffer = []

      this.$root.PlayAudio("assets/audio/send_message.wav")
    }
  },
  created() {
    this.val = this.value
  },
  mounted() {
    this.resize()
  }
}
</script>